import React, { Component } from "react";
import DesignSelectPopup from "../DesignSelect/DesignSelectPopup/DesignSelectPopup";
import axios from "axios";
import { FilteredView } from "../DesignSelect/FilteredView/FilteredView";
import Loading from '@/Common/loading/loading'
import { Route } from "react-router-dom";
import { GetBaseUrl } from '@/utils/ConfigHelper'
import { mode } from "webconfig";
import { _getTemplateById } from "../Home";
import i18n from "../i18n";
import { connect } from 'react-redux'
import InduceClickText from "../DesignSelect/InduceClickText/InduceClickText";
import Category from "../DesignSelect/Category/Category";
import NewCategory from '../DesignSelect/NewCategory'
import BusinessCategory from "../DesignSelect/BusinessCategory";
import LastViewWidget from '../DesignSelect/LastViewWidget'
import qs from 'query-string'
import * as LastViewTemplateHelper from '@/utils/LastViewTemplateHelper'

import { REDUX_ACTION } from '../Redux/action'
import { ReduxBinding } from '@/Redux/instance'
import { FetchPaymetMode, FetchCoupons, FetchAccountStatus, FetchLastViewTemplates } from '../Interface'

import ReactGA from 'react-ga'
import "./designSelect.scss";

class designSelect extends Component {

  constructor(props) {
    super(props)

    this.state = {
      isDialogOpened: false,
      selectedVideoId: null,
      templates: [],
      filteredTemplates: undefined,
      filteredTemplatesTotalCount: undefined,
      filterRequested: false,

      businessCategory: {
        전체: true,
        뷰티: false,
        패션: false,
        "카페/음식/베이커리": false,
        "숙박/여행/레저": false,
        "헬스/스포츠": false,
        "E커머스/쇼핑몰": false,
        부동산: false,
        "교육 서비스": false,
        "병원/전문직": false,
        '이벤트/홍보': false,
        "앱/모바일게임": false,
        "소셜 영상": false,
        "전단지": false,
        "Youtube 타이틀": false,
        "VLog": false,
        기타: false
      },
      styleCategory: {
        // 전체: true,
        역동적: false,
        경쾌한: false,
        감성적: false,
        심플한: false,
        빈티지: false,
        흑백: false,
        컬러풀한: false,
        귀여운: false,
        계절감: false,
        자막위주: false,
      },
      lengthFilter: {
        "0-10": false,
        "10-15": false,
        "15-20": false,
        "20-25": false,
        "25-30": false,
        "30-": false,
      },
      imageCountFilter: {
        "0-0": false,
        "1-5": false,
        "5-10": false,
        "10-15": false,
        "15-": false,
      },
      colorFilter: {},
      sort: {},
      isShowEditableOnly: false,
      searchString: '',
      isExpandCategoryOnInit: false,

      currentPage: 0,
      cardsPerPage: 21,


      //// LEGACY ////
      // lengthCategory : {
      //   "10초 이하" : false,
      //   "20초 이하" : false,
      //   "30초 이하" : false,
      //   "40초 이하" : false,
      // },
      // whichMainCateGoryClick : "marketing",
    };
    
    // const obj = qs.parse(window.location.search, { ignoreQueryPrefix: true })
    // if (obj) {
    //   if (obj.category === 'marketing') this.state.whichMainCateGoryClick = 'marketing'
    //   else if (obj.category === 'social') this.state.whichMainCateGoryClick = 'social'

    //   if (obj.searchString) this.initSearchString = obj.searchString

    //   const num = Number(obj.num)
    //   if (!isNaN(num)) {
    //     let targetCategory = {}
    //     if (this.state.whichMainCateGoryClick === 'marketing') targetCategory = this.state.businessCategory
    //     else if (this.state.whichMainCateGoryClick === 'social') targetCategory = this.state.styleCategory

    //     const keys = Object.keys(targetCategory)
    //     if (num < keys.length) {
    //       for (let i=0; i<keys.length; i++) {
    //         targetCategory[keys[i]] = num === i
    //       }
    //     }
    //   }
    // }

    const obj = qs.parse(window.location.search, { ignoreQueryPrefix: true })
    if (obj) {      
      const { searchString, business_category: businessCategory, style_category: styleCategory } = obj

      if (searchString) {
        this.state.searchString = searchString
        this.state.isExpandCategoryOnInit = true
      }
      else if (businessCategory) {
        this.state.businessCategory[businessCategory] = true
        this.state.isExpandCategoryOnInit = true
      }
      else if (!businessCategory) {
        this.state.businessCategory['전체'] = true
      }
      else if (styleCategory) {
        this.state.styleCategory[styleCategory] = true
        this.state.isExpandCategoryOnInit = true
      }
    }
  }

  templateGroupMap = {}

  async componentDidMount() {
    const { currentUser, history } = this.props
	if (history.location.state && history.location.state.businessCategory) {
        this.setState({ businessCategory: { [history.location.state.businessCategory]: true } }, this.filterTemplates)
	}
    if (currentUser) {
      FetchPaymetMode()
      FetchCoupons()
      FetchAccountStatus()
      FetchLastViewTemplates()
    }
    else {
      ReduxBinding(REDUX_ACTION.LASTVIEW_TEMPLATES, LastViewTemplateHelper.GetLastViewTemplateFromLocal())
    }
    
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    this.filterTemplates()

    const obj = qs.parse(window.location.search, { ignoreQueryPrefix: true })
    if (obj) {
      const { template_id: tempalteId } = obj
      if (tempalteId) {
        const response = await axios.post(`${GetBaseUrl()}/api/template/group-info`, { id: tempalteId })
        if (response && response.data) {
          const groupData = response.data

          let key
          for (let curKey in groupData.item) {
            if (groupData.item[curKey]._id === tempalteId) {
              key = curKey
              break
            }
          }

          this.templateGroupMap[groupData.name] = groupData
          this.onThumbnailClicked(groupData, key)()
        }
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      this.setState({ filteredTemplates: undefined }, this.filterTemplates)
    }
  }

  onThumbnailClicked = (groupData, key) => async () => {
    const { currentUser, lastViewTemplates } = this.props
    if (!groupData || !groupData.item || !groupData.item[key]) return

    const { _id, groupName } = groupData.item[key]
    
    const templates = await this.getTemplateById(_id);
    axios.post(`${GetBaseUrl()}/api/template/inc_views` , 
      {template_id : _id}
      ).then().catch()

    if (currentUser) {
      // 로그인 되어있을 시 POST로 last-view-template 등록
      const token = localStorage.getItem('token')
      axios.post(`${GetBaseUrl()}/api/user/last-view-template`, { name: groupName }, { headers: { Authorization: `Bearer ${token}` } })
        .then(() => {
          let isExists = false
          for (let i=0; i<lastViewTemplates.length; i++) {
            if (lastViewTemplates[i].name === groupName) {
              isExists = true
              break
            }
          }

          // 최대 20개까지만 저장 (groupKey 안겹치게)
          if (!isExists) ReduxBinding(REDUX_ACTION.LASTVIEW_TEMPLATES, [ groupData, ...(lastViewTemplates.slice(0, 19)) ])
        })
        .catch(() => { })
    }
    else {
      // 로그인 안되어있을 시 
      const resultArr = LastViewTemplateHelper.AddLastViewTemplateToLocal(groupData)
      ReduxBinding(REDUX_ACTION.LASTVIEW_TEMPLATES, resultArr)
    }
    this.setState({ templates, isDialogOpened: true, selectedVideoId: _id });
  };

  closeDialog = () => {
    this.setState({ isDialogOpened: false, selectedVideoId: null });
  };
  
  getTemplateById = async (videoId) => {
    return _getTemplateById(videoId)
  };

  // onCheckboxChanged = (categoryName, name) => event => {
  //   if (name === "전체") {
  //     this.setState({
  //         [categoryName]: { "전체": true },
  //         filterRequested: true
  //       },
  //       this.filterTemplates
  //     )
  //   } 
  //   else if (categoryName === 'lengthCategory') {
  //     const togggleTargetBoxOnly = {
  //       ...this.state[categoryName],
  //       [name]: event.target.checked
  //     }
  //     this.setState(
  //       {
  //         [categoryName]: togggleTargetBoxOnly,
  //         filterRequested: true
  //       },
  //       this.filterTemplates
  //     );
  //   } 
  //   else {
  //     if (this.state[categoryName][name]) return
  //     this.setState(
  //       {
  //         businessCategory: { "전체": true },
  //         styleCategory: { "전체": true },
  //         [categoryName]: {
  //           "전체": false,
  //           [name]: true
  //         },
  //         filterRequested: true
  //       },
  //       this.filterTemplates
  //     );
  //   }
  // };

  onVideoLikedButtonClicked = (selectedVideo, likedVideos) => e => {
    _onVideoLikedButtonClicked(this, selectedVideo, likedVideos);
  };

  filterTemplates = async (pageIndex = 0) => {
    // const business = Object.keys(this.state.businessCategory).filter(
    //   filterName =>
    //     filterName !== "전체" && this.state.businessCategory[filterName]
    // );
    // const style = Object.keys(this.state.styleCategory).filter(
    //   filterName =>
    //     filterName !== "전체" && this.state.styleCategory[filterName]
    // );
    // const runningTime = Object.keys(this.state.lengthCategory).filter(
    //   filterName => filterName !== "전체" && this.state.lengthCategory[filterName]
    // ).map(runningTimeName => runningTimeName.split(' ')[0].split('초')[0]);

    // const inputValue = document.getElementById("inputValue");
    // let searchString = ''
    
    // if (this.initSearchString) {
    //   searchString = String(this.initSearchString)
    //   this.initSearchString = null

    //   function setInitSearchStringToInputValueDOM() {
    //     const el = document.getElementById("inputValue")
    //     if (el) el.value = searchString
    //     else setTimeout(setInitSearchStringToInputValueDOM, 50)
    //   }
    //   setInitSearchStringToInputValueDOM()
    // }
    // if (inputValue) searchString = inputValue.value

    const {
      businessCategory,
      styleCategory,
      lengthFilter,
      imageCountFilter,
      colorFilter,
      sort,
      isShowEditableOnly,
      searchString,
      
      cardsPerPage
    } = this.state

    // INDONESIA CODE
    const lang = this.props.value === 'id' ? 'en' : this.props.value
    const filteringDatas = {
      searchString,
      pageIndex,
      pageItemCount: cardsPerPage,
      category_1: Object.keys(businessCategory).filter(key => key !== "전체" && businessCategory[key] === true),
      category_2: Object.keys(styleCategory).filter(key => styleCategory[key] === true),
      lang,
      order: sort['hot'] === true ? 1 : 0,

      lengthFilter: Object.keys(lengthFilter).filter(key => lengthFilter[key] === true),
      imageCountFilter: Object.keys(imageCountFilter).filter(key => imageCountFilter[key] === true),
      isShowEditableOnly
    };

    const colors = Object.keys(colorFilter).filter(key => colorFilter[key] === true)
    if (colors.length > 0) {
      filteringDatas.colors = colors
    }

    const response = await axios.post(`${GetBaseUrl()}/api/template/group-list`, filteringDatas)
    if (response && response.data) {
      if (mode === 'stage') {
        if (pageIndex > 0) {
          ReactGA.pageview(`/designselect?page=${(Number(pageIndex) + 1)}`)
        }

        if (Array.isArray(window.dataLayer) && typeof searchString === 'string') {
          window.dataLayer.push({
            event: 'tag_template_search',
            searchTerm: searchString.split('#').filter(item => item.length > 0).join(',')
          })
        }
      }

      const { dataArr, filteredCount } = response.data
      if (Array.isArray(dataArr)) {
        dataArr.forEach(item => {
          this.templateGroupMap[item.name] = item
        })
      }

      this.setState({
        filteredTemplates: dataArr,
        filteredTemplatesTotalCount: filteredCount,
        filterRequested: true,
        currentPage: pageIndex
      })
    }
  }; 

  changeSelectedVideo = async (newlySelectedVideoId) => {
    if (!this.state.templates) {
      return;
    }
    const refindTemplates = await this.getTemplateById(newlySelectedVideoId)
    this.setState({ templates: refindTemplates, selectedVideoId: newlySelectedVideoId });
  }

  onPageNumberClicked = newPage => async event => {
    await this.filterTemplates(newPage)
  };
  onPreviousPageClicked = newPage => async event => {
    await this.filterTemplates(newPage)
  };
  onNextPageClicked = newPage => async event => {
    await this.filterTemplates(newPage)
  };
  changeCardsPerPage = (newCardsPerPage) => {
    this.setState({ cardsPerPage: newCardsPerPage })
  }

  showOrderReviewComponent = (orderReviewType, locationState) => {
    this.setState({ showOrderReview: true, orderReviewType }, () => {
      this.props.history.push({
        pathname: `/payment/orderReview`,
        state: {
          orderReviewType, 
          ...locationState
        }
      });
    });
  };

  handleChangeFilter = (param = {}) => {
    const { name, key, value } = param

    switch (name) {
      case 'colorFilter':
        const org = this.state[name];
        this.setState(
          {
            [name]: {
              [key]: !org[key],
            },
          },
          this.filterTemplates
        );
        break;
      case 'styleCategory':
      case 'lengthFilter':
      case 'imageCountFilter':
        {
          const org = this.state[name]
          this.setState({
            [name]: {
              ...org,
              [key]: !org[key]
            }
          }, this.filterTemplates)
        }
        break
      case 'businessCategory':
      case 'sort':
        this.setState({ [name]: { [key]: true } }, this.filterTemplates)
        break

      case 'searchString':
      case 'isShowEditableOnly':
        this.setState({ [name]: value }, this.filterTemplates)
        break

      default:
        break
    }
  }

  handleChangeSearchString = e => this.setState({ searchString: e.target.value })
  
  //// LEGACY ////
  // searchBtnClick = (e) =>{
  //   e.preventDefault()
  //   this.filterTemplates()
  // }
  
  // handleSizeButtonClick = (categoryName, name ) => (event) =>{
  //   if (name === "전체" && this.state[categoryName]["전체"] === false) {
  //     const allSelected = Object.keys(this.state[categoryName]).reduce(
  //       (accum, filterName) => {
  //         accum[filterName] = true;
  //         return accum;
  //       },
  //       {}
  //     );
  //     this.setState(
  //       {
  //         [categoryName]: allSelected,
  //         filterRequested: true
  //       },
  //       this.filterTemplates
  //     );
  //   } else if (name === "전체" && this.state[categoryName]["전체"] === true) {
  //     const allDeselected = Object.keys(this.state[categoryName]).reduce(
  //       (accum, filterName) => {
  //         accum[filterName] = false;
  //         return accum;
  //       },
  //       {}
  //     );
  //     this.setState(
  //       {
  //         [categoryName]: allDeselected,
  //         filterRequested: true
  //       },
  //       this.filterTemplates
  //     );
  //   }
  //   else {
  //     this.setState(
  //       {
  //         [categoryName]: {
  //           ...this.state[categoryName],
  //           [name]: !this.state[categoryName][name]
  //         },
  //         filterRequested: true
  //       },
  //       this.filterTemplates
  //     );
  //   }
  // }
  // handleClickMainCategoryButton = (categoryName) => {
  //   this.setState({whichMainCateGoryClick : categoryName})
  // }

  render() {
    const {
      isDialogOpened,
      selectedVideoId,
      templates,
      filteredTemplates,
      filteredTemplatesTotalCount,
      filterRequested,
      currentPage,
      cardsPerPage,

      businessCategory,
      styleCategory,
      lengthFilter,
      imageCountFilter,
      colorFilter,
      sort,
      isShowEditableOnly,
      searchString,
      isExpandCategoryOnInit

      //// LEGACY ////
      // businessCategory,
      // styleCategory,
      // lengthCategory,
      // whichMainCateGoryClick
    } = this.state;
    const { match, history } = this.props;
    const { lastViewTemplates } = this.props
    const styleContainer = {
      // background : "#fefefe",
      // margin: '0 auto',
      // display: 'inline-block',
      // width: '1280px'
    }
    if (filteredTemplates === undefined) {
      return <Loading />;
    }

    // INDONESIA CODE
    const lang = this.props.value === 'id' ? 'en' : this.props.value

    return (
      <div className="design-select-container" style={styleContainer}>
        <div className="design-select-content">
          <div className="design-select-header">
            <InduceClickText {...this.props}></InduceClickText>
          </div>

          <div className="design-select-body">
            <div className="left-side">
              <BusinessCategory
                filter={{
                  businessCategory,
                  searchString
                }}
                handleChangeFilter={this.handleChangeFilter}
                handleChangeSearchString={this.handleChangeSearchString}
                handleClickSearchBtn={this.filterTemplates}
              />
            </div>

            <div className="right-side">
              <div className="right-side-content">
                <NewCategory
                  filter={{
                    styleCategory,
                    lengthFilter,
                    imageCountFilter,
                    colorFilter,
                    sort,
                    isShowEditableOnly,
                    searchString
                  }}
                  isExpandOnInit={isExpandCategoryOnInit}
                  handleChangeFilter={this.handleChangeFilter}
                  handleChangeSearchString={this.handleChangeSearchString}
                  handleClickSearchBtn={this.filterTemplates}
                />

                <Route
                  path={`${match.url}`}
                  component={props => (
                    <FilteredView
                      // INDONESIA CODE
                      isOld={true}
                      isVM={true}
                      cardSize={{ width: "123.75px", height: "220px" }} // 0.5625
                      value={lang}
                      filteredTemplates={filteredTemplates}
                      filteredTemplatesTotalCount={filteredTemplatesTotalCount}
                      onThumbnailClicked={this.onThumbnailClicked}
                      history={history}
                      filterRequested={filterRequested}
                      currentPage={currentPage}
                      cardsPerPage={cardsPerPage}
                      changeCardsPerPage={this.changeCardsPerPage}
                      onPageNumberClicked={this.onPageNumberClicked}
                      onPreviousPageClicked={this.onPreviousPageClicked}
                      onNextPageClicked={this.onNextPageClicked}
                    />
                  )}
                />
              </div>

              <div className="right-side-content-lastview">
                <LastViewWidget
                  templates={lastViewTemplates}
                  onThumbnailClicked={this.onThumbnailClicked}
                />
              </div>
            </div>

            <DesignSelectPopup
              closeDialog={this.closeDialog}
              isDialogOpened={isDialogOpened}
              templateGroupMap={this.templateGroupMap}
              selectedVideo={
                templates.filter(template => template._id === selectedVideoId)[0]
              }
              onVideoLikedButtonClicked={this.onVideoLikedButtonClicked}
              history={history}
              changeSelectedVideo={this.changeSelectedVideo}
            />
          </div>
        </div>
      </div>
    );
  }
}

export const _onVideoLikedButtonClicked = async (
  self,
  selectedVideo,
  likedVideos
) => {
  if (!selectedVideo || !Array.isArray(likedVideos)) return
  const { groupName } = selectedVideo

  const token = localStorage.getItem('token')
  try {
    const isLike = !likedVideos.includes(groupName)
    const newLikedTemplate = [...likedVideos]

    if (isLike) {
      newLikedTemplate.push(groupName)
      await axios.post(
        `${GetBaseUrl()}/api/user/like-template-name`,
        { name: groupName },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      )
    }
    else {
      newLikedTemplate.splice(likedVideos.indexOf(groupName), 1)
      await axios.delete(
        `${GetBaseUrl()}/api/user/like-template-name?name=${groupName}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      )
    }
    ReduxBinding(REDUX_ACTION.LIKE_TEMPLATES, newLikedTemplate)
  }
  catch (e) {

  }
};

export const randomSortArray = normalArray => {
  normalArray.sort((a, b) => {
    return Math.random() - Math.random();
  });
};

const mapStateToProps = state => ({
  value: state.langStore.lang,
  currentUser: state.userStore.user,
  lastViewTemplates: state.lastViewTemplatesStore.lastViewTemplates
})

export default connect(
  mapStateToProps,
  null
)
(designSelect)